export default "__VITE_ASSET__D80SFEi0__"